import { render, staticRenderFns } from "./BuildingEnergyConsumption.vue?vue&type=template&id=55642f4e&scoped=true&"
import script from "./BuildingEnergyConsumption.vue?vue&type=script&lang=js&"
export * from "./BuildingEnergyConsumption.vue?vue&type=script&lang=js&"
import style0 from "./BuildingEnergyConsumption.vue?vue&type=style&index=0&id=55642f4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55642f4e",
  null
  
)

export default component.exports